export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-2xl font-heading font-bold text-background-50">
              91电影
            </span>
            <p className="mt-3 text-sm text-background-400 leading-relaxed max-w-xs">
              全网最全的国产91电影聚集地，每日更新最新国产大片推荐，免费高清看国货精品，告别片荒从这里开始。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-200 mb-4">快速导航</h4>
            <ul className="space-y-3">
              {[
                { label: '精选推荐', href: '#cards' },
                { label: '最新动态', href: '#updates' },
                { label: '热门榜单', href: '#ranking' },
                { label: '常见问答', href: '#faq' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-background-500 hover:text-background-200 transition-colors whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-200 mb-4">内容索引</h4>
            <ul className="space-y-3">
              {[
                { label: '话题标签', href: '#topics' },
                { label: '专题合集', href: '#index' },
                { label: '媒体展示', href: '#media' },
                { label: '联系我们', href: '#contact' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-background-500 hover:text-background-200 transition-colors whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-200 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              诚邀优质内容方与平台加入合作，共同打造国产电影精品生态。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 91电影 - 国产电影在线推荐平台。本站内容仅供展示，不提供实际播放服务。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">回到顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}